module.exports = __webpack_public_path__ + "img/aland-islands.e22c9be3.png";